import axios from 'axios'
import api from './api'
import store from './store'
import router from './router'

axios.defaults.withCredentials = true
axios.defaults.baseURL = api

axios.interceptors.response.use(
  response => response,
  err => {
    if (err.response && err.response.status === 401) {
      if (store.state.authenticated) {
        store.commit('logout')
        router.push('/login')
        router.app.$notify({
          message: 'Session abgelaufen',
          type: 'danger'
        })
      }
    }
    return Promise.reject(err)
  }
)

export default axios
